export const uploadsHistoryTranslation = {
  actions: {
    continue: 'Kontynuuj',
    resolveErrors: 'Rozwiąż błędy',
    viewResolvedErrors: 'Podejrzyj rozwiązane błędy',
  },
  columns: {
    actions: 'Akcje',
    createdAt: 'Data utworzenia',
    creator: 'Twórca',
    fileName: 'Nazwa pliku',
    progress: 'Postęp',
    status: 'Status',
    type: 'Typ',
  },
  filters: {
    status: 'Status',
    uploadType: 'Typ uploadu',
  },
  status: {
    AWAITING_VALIDATION_RESOLUTION: 'Oczekiwanie na rozwiązanie',
    ERROR: 'Błąd',
    FINISHED: 'Zakończono',
    IN_PROGRESS: 'W toku',
    NOT_STARTED: 'Nie rozpoczęto',
    PROCESSING_CHUNKS: 'Przetwarzanie fragmentów',
    READING_DOCUMENT: 'Wczytywanie dokumentu',
    VALIDATION_FAILED: 'Błąd walidacji',
  },
  title: 'Historia uploadów',
  types: {
    CHAT_DOCUMENT: 'Dokument czatu',
    COMPANY_POSITIONS: 'Stanowiska',
    DEVELOPMENT_ACTIVITIES: 'Aktywności rozwojowe',
    DOCUMENT: 'Dokument',
    EDUAKCJA: 'Edukacja',
    EMPLOYEE_DATA: 'Dane pracowników',
    EMPLOYEES: 'Pracownicy',
    EMPLOYEES_EMPLOYMENT_HISTORY: 'Historia zatrudnienia',
    EMPLOYEES_ENABLE_CHANGE: 'Zmiana aktywności',
    MDR: 'MDR',
    SUCCESSION_DATA: 'Dane sukcesji',
    SYSTEM_USERS: 'Użytkownicy systemu',
  },
};

export type UploadsHistoryTranslation = typeof uploadsHistoryTranslation;
